export default __webpack_public_path__ + "static/telegram-c422cb1f0e8f7667aefacf594342699b.gif";